import { BreedSize, MeasurementCodeType } from '@app/shared/utils/enums';

export const lifestageTypeTranslationCodes = [
  { code: 'baby', value: 'lifestage-baby' },
  { code: 'kitten', value: 'lifestage-kitten' },
  { code: 'puppy', value: 'lifestage-puppy' },
  { code: 'adult', value: 'lifestage-adult' },
  { code: 'mature', value: 'lifestage-mature' },
  { code: 'ageing', value: 'lifestage-ageing' },
  { code: 'advanced ageing', value: 'lifestage-advanced-ageing' },
  { code: 'senior', value: 'lifestage-ageing' },
  { code: 'junior', value: 'lifestage-junior' },
  { code: 'All', value: 'lifestage-all' },
];

export const sizesTranslationCodes = [
  { code: BreedSize.XSmall, value: 'size-x-small' },
  { code: BreedSize.Small, value: 'size-mini' },
  { code: BreedSize.Medium, value: 'size-medium' },
  { code: BreedSize.Large, value: 'size-maxi' },
  { code: BreedSize.XLarge, value: 'size-giant' },
];

export const measurementUnitsSuffixesTranslationCodes = [
  { code: MeasurementCodeType.Gram, value: 'measurement_gram-suffix' },
  { code: MeasurementCodeType.Kilogram, value: 'measurement_kilogram-suffix' },
  { code: MeasurementCodeType.Ounce, value: 'measurement_ounce-suffix' },
  { code: MeasurementCodeType.Pound, value: 'measurement_pound-suffix' },
  { code: MeasurementCodeType.GramPerMegacalory, value: 'measurement_g-mcal' },
  { code: MeasurementCodeType.MilligramPerMegacalory, value: 'measurement_mg-mcal' },
  { code: MeasurementCodeType.KilocaloryPerKilogram, value: 'measurement_kcal-kg' },
  { code: MeasurementCodeType.Unit, value: 'measurement_unit-suffix' },
];
